import React, { useEffect, useState } from "react";
import { colors, fonts, flags } from "../../Styles";
import { SelectFieldOption_Values } from "../../Definitions";
import i18n from 'i18next'
import { CreateLangArr, languagObject } from "../../Translations";
import Select from "react-select";
import { components } from "react-select";

interface LanguageSelector_Props {
  isPrimary: boolean
}

export default function LanguageSelector({isPrimary}:LanguageSelector_Props) {
  const options = CreateLangArr()

  const capitalizeFirstLetter = (text: string) => {
    return text.toUpperCase()
  };

  const [currentSelected, setcurrentSelected] = useState<languagObject>(() => {
    const selected = options.find(e => e.id === i18n.language) || CreateLangArr(i18n.language, i18n.language)[0];
    return {
      ...selected,
      label: capitalizeFirstLetter(selected.label)
    };
  });

  useEffect(() => {
    const item = options.find(e => e.id === currentSelected.id);
    if (item) {
      i18n.changeLanguage(item.id); 
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSelected]);

  const _icon = (id: string) => {
    try {
      // const imagePath = require(`../Assets/Flags/${id}.png`);
      const imagePath = flags[id] as string | undefined;
      return <img style={{ width: "20px" }} src={imagePath} alt={id} />;
    } catch (error) {
      console.warn(`Image not found for id: ${id}`);
      return <></>;
    }
  };

  const OptionWithIcon = (props: any) => {
    const { data, children, ...rest } = props;
    return (
      <components.Option {...rest}>
        <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {data.icon}
          {children}
        </span>
      </components.Option>
    );
  };

  return(
    <div style={{position: "relative"}}>
  <Select<SelectFieldOption_Values>
    value={currentSelected}
    onChange={(option) => {
      if (option) {
        setcurrentSelected({ ...option, id: String(option.id) }); 
      }
    }}
    options={options.map(option => ({ label: option.label, id: option.id, icon: _icon(option.id) }))}
    menuPortalTarget={document.body} 
    isSearchable={false}
    menuPlacement={"auto"}
    getOptionLabel={(option) => option.label}
    getOptionValue={(option) => String(option.id ?? option.label)}
    formatOptionLabel={(option, { context }) => (
      <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {capitalizeFirstLetter(option.label)}
      </span>
    )}
    components={{Option: OptionWithIcon}}
    styles={{
      container: (baseStyles) => ({
        ...baseStyles,
        width: "20px",
        height: "30px",
        ...fonts.header,
        ...fonts.fontSize4,
        paddingRight: isPrimary ? "20px" : undefined,
        boxSizing: isPrimary ? "content-box" : undefined
      }),
      control: (baseStyles) => ({
        ...baseStyles,
        backgroundColor: colors.transparent,
        border: "none",
        borderRadius: "10px",
        boxShadow: "none",
        cursor: "pointer",
        minHeight: "unset",
      }),
      valueContainer: (baseStyles) => ({
        ...baseStyles,
        padding: "0px",
        height: "30px"
      }),
      input: (baseStyles) => ({
        ...baseStyles,
        color: colors.greyLightTertiary,
        
      }),
      menu: (baseStyles) => ({
        ...baseStyles,
        backgroundColor: colors.greyDarkPrimary,
        borderRadius: "10px",
        width: "180px",
        marginBottom: isPrimary ? "15px" : "0px",
        right: isPrimary ? "-20px" : "0px",
      }),
      menuList: (baseStyles) => ({
        ...baseStyles,
        backgroundColor: colors.greyDarkPrimary,
        borderRadius: "10px",
        padding: "10px 10px",
        overflowY: "hidden",
        ...fonts.header,
        ...fonts.fontSize4,
      }),
      option: (baseStyles, state) => ({
        ...baseStyles,
        borderRadius: "10px",
        margin: "3px 0px",
        color: colors.greyLightTertiary,
        backgroundColor: state.isSelected ? colors.greyDarkSecondary : colors.greyDarkPrimary,
        transition: "background-color 0.3s ease",
        "&:hover": {
          backgroundColor: colors.greyDarkSecondary,
          cursor: "pointer"
        }
      }),
      singleValue: (baseStyles) => ({
        ...baseStyles,
        color: colors.greyLightTertiary,
        display: "none"
      }),
      indicatorsContainer: (baseStyles) => ({
        ...baseStyles,
        display: "none"
      }), 
      indicatorSeparator: (baseStyles) => ({
        ...baseStyles,
        display: "none"
      }), 
      dropdownIndicator: (baseStyles) => ({
        ...baseStyles,
        display: "none",
      }), 
      menuPortal: (baseStyles) => ({
        ...baseStyles,
        zIndex: "99999999999999"
      })
    }}
  />
    <div style={{position: "absolute", height: "20px", top: "50%", transform: "translateY(-50%)", left: "0px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", pointerEvents: "none"}}>
      {_icon(currentSelected.id)}
    </div>
  </div>
)
}